import { useHistory, useLocation } from 'react-router-dom'
import useGroupedBasket from 'hooks/useGroupedBasket'
import React, { useEffect } from 'react'
import Summary from './Summary'
import List from './List'
import './style.scss'

interface BasketPopupProps {
  isDesktop?: boolean
}

const BasketPopup: React.FC<BasketPopupProps> = ({ isDesktop }) => {
  const list = useGroupedBasket()
  const { state } = useLocation()
  const { goBack } = useHistory()

  const isBasketExpanded = (state && typeof state === 'object' && 'popup' in state && state.popup === 'basket')

  useEffect(() => {
    const escDetect = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        goBack()
      }
    }

    document.addEventListener('keydown', escDetect, false)
    return () => {
      document.removeEventListener('keydown', escDetect, false)
    }
  }, [goBack])

  return (
    <div
      className={`basketPopup__bg${isBasketExpanded ? '' : ' --close'} ${isDesktop ? '--desktop' : ''}`}
      onClick={() => isDesktop ? goBack() : undefined}>
      <div className='basketPopup' onClick={(e) => e.stopPropagation()}>
        <List list={list} />
        <Summary list={list} />
      </div>
    </div>
  )
}

export default BasketPopup